import React from 'react';
import { Typography } from '@mui/material';
import { toHumanReadableDate } from '@shared/services/dateService';
import { naText } from '../../../../../constants/textConstants';

/**
 * @typedef {object} TimelineEventLabelProps
 * @property {Date} [date]
 * @property {string} label
 */

/**
 * @param {TimelineEventLabelProps} props
 */
const TimelineEventLabel = props => {
  const { date, label } = props;
  const text = !date ? naText : toHumanReadableDate(date);

  return (
    <Typography color='textSecondary'>
      {label}: {text}
    </Typography>
  );
};

export default TimelineEventLabel;
